export default "__VITE_ASSET__Bj$yeCIk__"